import { Calendar, dateFnsLocalizer } from "react-big-calendar";
import format from "date-fns/format";
import parse from "date-fns/parse";
import startOfWeek from "date-fns/startOfWeek";
import addHours from "date-fns/addHours";
import getDay from "date-fns/getDay";
import enUS from "date-fns/locale/en-US";
import "react-big-calendar/lib/css/react-big-calendar.css";
import Diary from "../features/Diary/interfaces/IDiary";
import { useEffect, useState } from "react";
import handleNullTimeEntries from "../utils/handleNullTimeEntries";

const locales = {
  "en-US": enUS,
};
const localizer = dateFnsLocalizer({
  format,
  parse,
  startOfWeek,
  getDay,
  locales,
});

interface IEvents {
  title: string;
  start: Date;
  end: Date;
}

const DiaryCalendar = (props: { diaryEntries: Diary[] }) => {
  const [events, setEvents] = useState<IEvents[]>([]);

  useEffect(() => {
    if (props) {
      props.diaryEntries.map((diaryEntry) => {
        setEvents((prev) => [
          ...prev,
          {
            title: diaryEntry.entry_title,
            end: addHours(
              handleNullTimeEntries(
                diaryEntry.entry_date,
                diaryEntry.entry_time
              ),
              1
            ),
            start: handleNullTimeEntries(
              diaryEntry.entry_date,
              diaryEntry.entry_time
            ),
          },
        ]);
      });
    }
  }, [props]);

  return (
    <div>
      <Calendar
        localizer={localizer}
        events={events}
        style={{ height: 500 }}
        toolbar={true}
        onSelectEvent={(event) => {
          //select the event.title in the context on the diary page, so when the user clicks on an event, it should display the event
          //with that name in the list below
        }}
        views={["month", "agenda"]}
      />
    </div>
  );
};

export default DiaryCalendar;
